import { render, staticRenderFns } from "./NuevaEmergenciaPage.vue?vue&type=template&id=a1042d28&"
import script from "./NuevaEmergenciaPage.vue?vue&type=script&lang=js&"
export * from "./NuevaEmergenciaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports